// AI App Templates for SuperTool AI

export const appTemplates = [
  {
    id: 'chatbot',
    name: 'AI Chatbot',
    category: 'Conversational AI',
    description: 'Build an intelligent chatbot with natural language understanding',
    icon: '💬',
    features: ['Real-time chat', 'Context awareness', 'Multi-turn conversations', 'Custom personality'],
    stack: 'react-fastapi',
    aiModel: 'claude',
    estimatedTime: '10 minutes',
    complexity: 'Easy',
    color: 'blue'
  },
  {
    id: 'content-generator',
    name: 'AI Content Writer',
    category: 'Content Creation',
    description: 'Generate blog posts, articles, and marketing copy with AI',
    icon: '✍️',
    features: ['Blog post generation', 'SEO optimization', 'Multiple tones', 'Export to PDF'],
    stack: 'react-fastapi',
    aiModel: 'grok',
    estimatedTime: '15 minutes',
    complexity: 'Easy',
    color: 'green'
  },
  {
    id: 'image-generator',
    name: 'AI Image Studio',
    category: 'Image Generation',
    description: 'Create stunning images from text descriptions',
    icon: '🎨',
    features: ['Text-to-image', 'Style customization', 'Multiple resolutions', 'Image gallery'],
    stack: 'react-fastapi',
    aiModel: 'openai',
    estimatedTime: '20 minutes',
    complexity: 'Medium',
    color: 'purple'
  },
  {
    id: 'code-assistant',
    name: 'Code Assistant',
    category: 'Developer Tools',
    description: 'AI-powered coding helper with code generation and debugging',
    icon: '💻',
    features: ['Code generation', 'Bug fixing', 'Code explanation', 'Multiple languages'],
    stack: 'react-fastapi',
    aiModel: 'claude',
    estimatedTime: '15 minutes',
    complexity: 'Medium',
    color: 'indigo'
  },
  {
    id: 'data-analyzer',
    name: 'Data Insights AI',
    category: 'Analytics',
    description: 'Upload data and get AI-powered insights and visualizations',
    icon: '📊',
    features: ['CSV upload', 'Auto analysis', 'Chart generation', 'Trend detection'],
    stack: 'react-fastapi',
    aiModel: 'openai',
    estimatedTime: '25 minutes',
    complexity: 'Medium',
    color: 'yellow'
  },
  {
    id: 'voice-assistant',
    name: 'Voice AI Assistant',
    category: 'Voice & Audio',
    description: 'Voice-activated AI assistant with speech recognition',
    icon: '🎤',
    features: ['Speech-to-text', 'Voice responses', 'Multi-language', 'Custom commands'],
    stack: 'react-fastapi',
    aiModel: 'openai',
    estimatedTime: '30 minutes',
    complexity: 'Hard',
    color: 'red'
  },
  {
    id: 'email-assistant',
    name: 'Smart Email Writer',
    category: 'Productivity',
    description: 'AI-powered email drafting and response generator',
    icon: '📧',
    features: ['Email drafting', 'Tone adjustment', 'Auto-reply', 'Templates'],
    stack: 'react-fastapi',
    aiModel: 'claude',
    estimatedTime: '12 minutes',
    complexity: 'Easy',
    color: 'teal'
  },
  {
    id: 'recipe-finder',
    name: 'AI Recipe Generator',
    category: 'Lifestyle',
    description: 'Get recipes based on ingredients or dietary preferences',
    icon: '🍳',
    features: ['Ingredient-based', 'Diet filters', 'Nutrition info', 'Shopping lists'],
    stack: 'react-fastapi',
    aiModel: 'grok',
    estimatedTime: '18 minutes',
    complexity: 'Easy',
    color: 'orange'
  },
  {
    id: 'social-media-manager',
    name: 'Social Media AI',
    category: 'Marketing',
    description: 'Generate and schedule social media content with AI',
    icon: '📱',
    features: ['Post generation', 'Hashtag suggestions', 'Image creation', 'Analytics'],
    stack: 'react-fastapi',
    aiModel: 'grok',
    estimatedTime: '22 minutes',
    complexity: 'Medium',
    color: 'pink'
  },
  {
    id: 'translation-tool',
    name: 'AI Translator Pro',
    category: 'Language',
    description: 'Real-time translation with context awareness',
    icon: '🌍',
    features: ['100+ languages', 'Context aware', 'Batch translation', 'Document support'],
    stack: 'react-fastapi',
    aiModel: 'claude',
    estimatedTime: '15 minutes',
    complexity: 'Easy',
    color: 'cyan'
  },
  {
    id: 'tutor-bot',
    name: 'AI Tutor',
    category: 'Education',
    description: 'Personalized learning assistant for any subject',
    icon: '📚',
    features: ['Any subject', 'Step-by-step explanations', 'Quiz generation', 'Progress tracking'],
    stack: 'react-fastapi',
    aiModel: 'claude',
    estimatedTime: '20 minutes',
    complexity: 'Medium',
    color: 'emerald'
  },
  {
    id: 'resume-builder',
    name: 'Smart Resume Builder',
    category: 'Career',
    description: 'AI-powered resume and cover letter generator',
    icon: '📄',
    features: ['ATS-friendly', 'Industry-specific', 'Cover letters', 'Multiple formats'],
    stack: 'react-fastapi',
    aiModel: 'openai',
    estimatedTime: '15 minutes',
    complexity: 'Easy',
    color: 'violet'
  }
];

export const categories = [
  'All',
  'Conversational AI',
  'Content Creation',
  'Image Generation',
  'Developer Tools',
  'Analytics',
  'Voice & Audio',
  'Productivity',
  'Lifestyle',
  'Marketing',
  'Language',
  'Education',
  'Career'
];
